import { observer } from 'mobx-react-lite'
import { Box, Dropdown, DropdownContent, DropdownItem, Scrollbar } from 'shared/ui'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import styles from './styles.module.scss'

type IDaysDropdownProps = {
  followUpWindow: number
  setFollowUpWindow: (value: number) => void
  days: { value: number; label: string }[]
  label: string
}

export const DaysDropdown = observer(
  ({ followUpWindow, setFollowUpWindow, days, label }: IDaysDropdownProps) => {
    return (
      <div className={styles.followUpWindowWrapper}>
        <span className={styles.followUpWindowLabel}>{label}</span>
        <Box display={'flex'} alignItems={'center'} paddingRight={'20px'}>
          <Dropdown
            width={59}
            placement='bottom'
            triggerComponent={() => (
              <TextFieldPlaceholder
                className={styles.followUpValue}
                size='small'
                variant='outline'
                placeholder={followUpWindow}
                rightActions={[makeTextFieldIcon({ icon: 'chevronDown', fontSize: 12 })]}
              />
            )}
            customComponent={(close) => (
              <DropdownContent>
                <Scrollbar autoHeight autoHeightMax={'160px'}>
                  <div className={styles.dropdownList}>
                    {days.map((item, index) => (
                      <DropdownItem
                        key={item.value}
                        item={{
                          id: index,
                          label: item.label,
                          onClick: () => {
                            close()
                            setFollowUpWindow(item.value)
                          },
                        }}
                      />
                    ))}
                  </div>
                </Scrollbar>
              </DropdownContent>
            )}
          />
          <span className={styles.daysLabel}>{followUpWindow === 1 ? 'Day' : 'Days'}</span>
        </Box>
      </div>
    )
  }
)
